import React from 'react';
import { buildReasonPage } from './reasonPageBuilder';
import { apportionmentInformationText as txt } from '../../definitions/constants';
import { FIELDS, YES_NO, noPriorAnswerYes } from './helpers';

const competenceCriteria = (
  <div>
    <p>{txt.veteranCompetenceCriteriaLabel}</p>
    <ul>
      <li>
        Veteran is incompetent and without fiduciary (a competent person
        handling the Veteran’s finances), <strong>and</strong>
      </li>
      <li>
        Veteran is receiving hospital treatment, <strong>or</strong>
      </li>
      <li>
        Veteran is in a nursing home, <strong>or</strong>
      </li>
      <li>
        Veteran is receiving domiciliary (in home) care provided by the United
        States (Federal) or political subdivision (State or local),{' '}
        <strong>and</strong>
      </li>
      <li>
        Veteran’s benefits are not being paid to the Veteran’s spouse (38 U.S.C
        5307 and 5502)
      </li>
    </ul>
  </div>
);

export default buildReasonPage({
  path: 'veteran-competence',
  title: txt.veteranCompetencePageTitle,
  description: txt.reasonPageSubDescription,
  extraContent: competenceCriteria,
  depends: formData =>
    noPriorAnswerYes(formData, [
      FIELDS.veteranIncarceratedOver60Days,
      FIELDS.survivingBeneficiaryIncarceratedOver60Days,
    ]),
  trigger: {
    name: FIELDS.veteranIncompetentInCare,
    title: ' ',
    hint: txt.veteranCompetenceHintText,
    labels: txt.veteranCompetenceLabels,
    descriptions: txt.veteranCompetenceDescriptions,
    tile: true,
    options: YES_NO,
    error: txt.veteranCompetenceError,
  },
  conditionalFields: [
    {
      type: 'text',
      name: FIELDS.veteranCompetenceFacilityName,
      title: txt.veteranCareFacilityNameTitle,
      maxLength: 150,
      error: txt.veteranCompetenceFacilityNameError,
    },
    {
      type: 'text',
      name: FIELDS.veteranCompetenceFacilityAddress,
      title: txt.facilityAddressTitle,
      maxLength: 500,
      error: txt.veteranCompetenceFacilityAddressError,
    },
  ],
});
